export default "{\n    \"label\": \"Catégories\",\n    \"placeholderText\": \"Sélectionner les catégories\"\n}\n"